import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { GridColDef } from "@mui/x-data-grid";
import TableComponent from "../../components/TableComponent";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useLazyGetRoleByIdQuery } from "../../services/accessRole";
import { showError } from "../../constants/toasts";
import { useEffect, useMemo, useState } from "react";

const RoleDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams()
  const [getById] = useLazyGetRoleByIdQuery()
  const [loading, setLoading] = useState<boolean>()
  const [role, setRole] = useState<any>(null)

  const fetchUser = async () => {
    try {
      if (!id) return;
      setLoading(true)
      const res = await getById({ id }).unwrap();
      if (res?.statusCode === 200) {
        setRole(res?.data)
      }
    } catch (error: any) {
      showError(error?.data?.message || error?.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (id) {
      fetchUser()
    }
  }, [id])

  const mappedRows = useMemo(() => {
    const list = role?.permission || [];
    return list.map((p: any) => ({
      id: p?._id || p?.id || p?.sideBarId,
      name: p?.label,
      addEdit: Boolean(p?.isAdd) || Boolean(p?.isEdit),
      delete: Boolean(p?.isDelete),
      view: Boolean(p?.isView),
    }));
  }, [role]);

  const columns: GridColDef<any>[] = [
    {
      flex: 1,
      minWidth: 180,
      field: "name",
      headerName: "Module Name",
      editable: false,
      sortable: false
    },
    {
      flex: 1,
      minWidth: 180,
      field: "addEdit",
      headerName: "Add / Edit",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        params?.row?.addEdit ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />
      )
    },
    {
      flex: 1,
      minWidth: 100,
      field: "delete",
      headerName: "Delete",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        params?.row?.delete ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />
      )
    },
    {
      flex: 1,
      minWidth: 180,
      field: "view",
      headerName: "View",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        params?.row?.view ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />
      )
    }
  ];
  let hidden = ["fullName"];

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Role Detail</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span>
          {' '} - <span onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</span>
          {' '} - <span onClick={() => navigate("/manage-subadmin/roles")}>Manage Roles</span>
          {' '} - Role Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="w_33">
            <h6>Role Name</h6>
            <p>{role?.name || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{role?.createdAt ? new Date(role.createdAt).toLocaleDateString() : '-'}</p>
          </div>
        </div>
        <div className="sorting_table mt_20">
          <TableComponent
            columns={columns?.filter((item) => !hidden.includes(item.field))}
            rows={mappedRows}
            getRowId={(row: any) => row.id}
            loading={loading}
          />
        </div>
      </div>
    </MainContainer>
  );
};

export default RoleDetail;
